import { FC, useMemo } from "react";
import { useParams } from "react-router-dom";
import ErrorBoundary from "@funded-here-interface/common/src/dashboard/components/ErrorBoundry";
import HeaderPmDashboard from "./HeaderPmDashboard";
import ActiveNotes from "./Components/ActiveNotes";
// // @ts-ignore
// import OverviewDashboard from "./Components/OverviewDashboard";
// // @ts-ignore
// import Investor from "./Components/Investor/Investor";
// // @ts-ignore
// import Repayment from "./Components/RepaymentTracking";
// // @ts-ignore
// import Note from "./Components/StructureNote/Structure";
// // @ts-ignore
// import SkuSummary from "./Components/SKUSummary/Skusummary";
// // @ts-ignore
// import MerchantSummary from "./Components/MerchantSummary/Merchant";
// // @ts-ignore
// import DailySalesReport from "./Components/DailySalesReport/Dailysales";
// import InvestorSummary from "./Components/Investor/InvestorSummary";
// import Skusummary from "./Components/SKUSummary/Skusummary";

const Dashboard: FC = () => {
  const { subpath } = useParams<{ subpath: string }>();

  const renderContent = useMemo(() => {
    switch (subpath) {
      case "activenotes":
        return <ActiveNotes />;
      // case "overview":
      //   return <OverviewDashboard />;
      // case "investor":
      //   return <Investor />;
      // case "tracking":
      //   return <Repayment />;
      // case "note":
      //   return <Note />;
      // case "skusummary":
      //   return <SkuSummary />;
      // case "merchant":
      //   return <MerchantSummary />;
      // case "dailysales":
      //   return <DailySalesReport />;
      // case "investorsummary":
      //   return <InvestorSummary />;
      // case "snusummary":
      //   return <Skusummary />;
      default:
        return <ActiveNotes />;
    }
  }, [subpath]);

  return (
    <ErrorBoundary>
      <div className="mainContainer">
        <HeaderPmDashboard />
        {renderContent}
      </div>
    </ErrorBoundary>
  );
};

export default Dashboard;
